export const NAME_MAX_LENGTH = 25;
export const TABNAME_MAX_LENGTH = 40;
export const DASHBOARD_PREFIX = 'dashboard-';
export const BASIC_DATA_TABLE_DISPLAY_ROWS = 20;

// Max items per widget
export const BASIC_DATA_TABLE_MAX_ITEMS = 30;
export const SPOT_CHART_MAX_ITEMS = 6;
export const SEASONAL_CHART_MAX_ITEMS = 1;
export const FWD_CHART_MAX_ITEMS = 2;
export const HIGHLIGHTED_PRICE_MAX_ITEMS = 8;
